// Passive Jubelio mapping indicator; renders nothing for unmapped/manual products.
export default function JubelioBadge({ product, mapped, size = 12, className = "" }) {
    if (!(mapped ?? product?.jubelio_product_id)) return null;
    return (
        <img
            src="/jubelio-mark.png"
            alt="Jubelio"
            title="Mapped to Jubelio"
            draggable={false}
            data-testid="jubelio-logo"
            style={{ height: size, width: "auto" }}
            className={`inline-block shrink-0 align-middle select-none pointer-events-none ${className}`}
        />
    );
}
